export * from './auth/auth';
export * from './auth/auth.module';
//# sourceMappingURL=auth.js.map


//////////////////
// WEBPACK FOOTER
// d:/xampp/htdocs/zenith-admin/~/angularfire2/auth.js
// module id = ../../../../angularfire2/auth.js
// module chunks = 4